
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-28 (1.0.0) (jhoward)
 *      - Add <menu-version> component to facilitate opening the options menu.
 */

import {defineComponent} from 'vue'

export default defineComponent({
  name: "menu-version",
  props: {
    version: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      clickCount: 0,
      clickThreshold: 4,
      clickTimer: -1,
      clickTimeout: 5000
    };
  },
  methods: {
    handleContainerClick() {
      window.clearTimeout(this.clickTimer);
      this.clickCount++;
      if (this.clickCount >= this.clickThreshold) {
        this.$store.commit('openOptionsMenu');
        this.clickCount = 0;
      } else {
        window.setTimeout(() => {
          this.clickCount = 0;
        }, this.clickTimeout);
      }
    }
  }
})
